import { apiSlice } from '../../api/apiSlice';

export const profileApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProfileInformation: builder.query({
      query: () => ({
        url: 'UserAccount/GetProfileInformation',
        method: 'GET'
      })
    }),
    checkProfileInformation: builder.query({
      query: () => ({
        url: 'UserAccount/CheckProfileInformation',
        method: 'GET'
      })
    }),
    getProfileCategories: builder.query({
      query: () => ({
        url: 'UserAccount/GetProfileCategories',
        method: 'GET'
      })
    }),
    updateProfileInformation: builder.mutation({
      query: (profileInfo) => ({
        url: 'UserAccount/UpdateProfileInformation',
        method: 'POST',
        body: profileInfo
      })
    }),
    unlinkGoogleClassroom: builder.mutation({
      query: () => ({
        url: 'UserAccount/UnlinkGoogleClassroom',
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    getProfileCompletionPercentage: builder.query({
      query: () => ({
        url: 'UserAccount/GetProfileCompletionPercentage',
        method: 'GET'
      })
    })
  })
});

export const {
  useGetTestNamesQuery,
  useLazyGetProfileInformationQuery,
  useGetProfileCategoriesQuery,
  useUpdateProfileInformationMutation,
  useCheckProfileInformationQuery,
  useUnlinkGoogleClassroomMutation,
  useGetProfileCompletionPercentageQuery
} = profileApiSlice;
